import React from "react";
import constants from "../../utils/constants";
import { Navigate } from "react-router-dom";

const HomePage = () => {
    return <Navigate to={constants.routePath.environments} />;
};

export default HomePage;
